import Organizacion from "./organizacion";
import {MTAConfig} from "../../services/familia/config";


export const Mta = (props) => {
    return (
        <Organizacion config={MTAConfig} {...props}/>
    )
}